/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { sendAccountActivationEmail } from "@eisinc/App/Services/SessionService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SendActivationEmail";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        userName: props.parameter.userName,
        activateAccount: props.parameter.activateAccount,
    };
};

export const XngSendDataToApi: any = async (props: any) => {
    props.apiResult = await sendAccountActivationEmail(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, SendDataToApi, XngSendDataToApi);
